import React from 'react'
import './crawltextInstance.css'

const Crawl = () => {
  return (
      <section className='star-warsI' >
        <div className=''>
          <div className=''>
            <h1>METAFEST ... Manifest the Future</h1>
          </div>

          <p>
            Besides having fun, the main purpose of everything we’re doing at
            MetaGame is to help people level up then help us build a new kind of
            socioeconomic system.
          </p>
          <p>
            One based around providing for human needs & solving problems rather
            than squeezing the world for ever more profit. Therefore, the talks
            & workshops will generally be about technologies of the future
            without leaving out the weird fringes.
          </p>
          <h1>Week I</h1>
          <p>
            Starting with a week of socializing through things like multiplayer
            games & speed dating.
          </p>
          <h1>Week II</h1>
          <p>
            Continuing with a week of talks from metagamers as well as from
            wider crypto & way outside of crypto.
          </p>
          <h1>Week III</h1>
          <p>
            Leading up to the launch of Season2 of MetaGame with a concert,
            going into days of workshops.
          </p>
          <h1>Week IV</h1>
          <p>
            And finally, culminating in a week & a half of hacking things
            together.
          </p>
          <p>So...</p>
          <p>
            Want to do a talk? Run a workshop? Lead a multiplayer game session?
            Help us manifest MetaFest? Something else entirely?
          </p>
          <h1>Yes, I do.</h1>
        </div>
      </section>
  )
}

export default Crawl
